const l = "wallet_NTzgA", a = "wallet__apple_iQ05q", t = "wallet__android_98nCb", e = {
  wallet: l,
  wallet__apple: a,
  wallet__android: t
};
export {
  e as default,
  l as wallet,
  t as wallet__android,
  a as wallet__apple
};
//# sourceMappingURL=addToWallet.module.scss.js.map
